import { View } from 'react-native';
import { styles } from './UserImageAreaSelectionOverlay.style';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { brand, neutrals } from '../../../theme/colors';
import { useEffect } from 'react';

export const UserImageAreaSelectionOverlayBody = ({
  focusable,
  focused,
  hovered,
  onHoverIn,
  onHoverOut,
}: {
  focusable: boolean;
  focused: boolean;
  hovered: boolean;
  onHoverIn: () => void;
  onHoverOut: () => void;
}) => {
  useEffect(() => {
    if (focusable) {
      if (focused) {
        onHoverIn();
      } else if (!hovered) {
        onHoverOut();
      }
    }
  }, [focusable, focused, hovered]);

  return (
    <>
      <View style={styles.selectionContainerBackground} />
      <View style={styles.selectionContainerItem}>
        <View style={styles.dragIcon}>
          <Icon name={ICON_NAMES.Drag} color={neutrals.white} />
        </View>
      </View>
      <View style={styles.cursorPointer}>
        <View style={styles.editIcon}>
          <Icon name={ICON_NAMES.Edit} color={brand.main.water} />
        </View>
      </View>
      <View style={styles.selectionContainerItem} />
    </>
  );
};
